


export const CONSTANTES = {
  FECHA_CAMPANIA: "29/05/2026"
};